/**
 * Toggles `childId` in a multi-select list: add if missing, remove if present.
 */
export function toggleSelectedChildId(
    selectedChildIds: number[],
    childId: number,
): number[] {
    if (selectedChildIds.includes(childId)) {
        return selectedChildIds.filter((id) => id !== childId);
    }

    return [...selectedChildIds, childId];
}
